import React from 'react'
import { AuthPage } from '@/user/pages/AuthPage'

export default function Homepage() {
  return <AuthPage />
}
